import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { InstallAgentPanelDataProvider } from '../dataProvider/InstallAgentPanelDataProvider';

export class InstallAgentPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, InstallAgentPanelDataProvider);
  }
}
